import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { reportError } from "../lib/reportError";

export const useAiModels = () => {
  const [catalog, setCatalog] = useState(null);
  const [error, setError] = useState("");
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setError("");
    api.get("/ai/models", { signal: controller.signal }).then(({ data }) => {
      if (!data.models?.length || !data.models.some(model => model.id === data.default_model)) {
        throw new Error("Invalid model catalog");
      }
      setCatalog(data);
    }).catch(error => {
      if (controller.signal.aborted) return;
      reportError("AI model catalog unavailable", error);
      setError("AI models could not be loaded. Please retry.");
    });
    return () => controller.abort();
  }, [attempt]);
  return { catalog, error, retry: () => setAttempt(value => value + 1) };
};